<script setup>
  import { ref, computed, watchEffect, onMounted } from 'vue'
  import { useStormStore } from "@/stores/StormStore";
  import { useSheetController } from "@/composables/useSheetsController";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();    

  const stormStore = useStormStore();

  const stormLayers = {};
  const stormLayerListener = ref(null);
  const currentStormId = ref(null);
  const allowKMLClick = ref(true);
  const allowKMLClickTimeout = ref(null);

  const activeStorms = computed(() => stormStore.activeStorms.length > 0);

  function addStormLayer() {
    if (stormLayerListener.value) {
      google.maps.event.removeListener(stormLayerListener.value);
    }

    if (currentStormId.value) stormLayers[currentStormId.value].setMap(null);
    
    if (!stormLayers[stormStore.selectedStorm.id]) {
      stormLayers[stormStore.selectedStorm.id] = new google.maps.KmlLayer(stormStore.stormForecastURL, { preserveViewport: false, suppressInfoWindows: true })
    }
    
    stormLayers[stormStore.selectedStorm.id].setMap(window.$JWX.map);    
    stormLayerListener.value = google.maps.event.addListener(stormLayers[stormStore.selectedStorm.id], "click", stormLayerClickHandler);
    
    currentStormId.value = stormStore.selectedStorm.id;
  }

  function stormLayerClickHandler(kmlEvent) {
    if (!allowKMLClick.value) return;

    const id = kmlEvent.featureData.id;

    stormStore.convertPointForecastToObject(id);
    useSheetController.toggleSheet('info', 'storm-forecast', true);
  }

  watchEffect(() => {
    activeStorms.value && stormStore.selectedStorm && addStormLayer();
  })

  onMounted(() => {
    if ($WEB_VIEW) {
      google.maps.event.addListener(window.$JWX.map, "click", function (e) {
        window.$JWX.cosmos.closeQuickView();
      })
    }

    google.maps.event.addListener(window.$JWX.map, "infowindow_clicked", function (e) {
      allowKMLClick.value = false;

      clearTimeout(allowKMLClickTimeout.value);

      allowKMLClickTimeout.value = setTimeout(() => {
        allowKMLClick.value = true;
      }, 1000);
    })
  })

</script>

<template></template>